module.exports = __webpack_public_path__ + "img/food_drink.aef91ab9.svg";